/**
 * File navigation.js.
 *
 * Handles showing / hiding main nav on scroll
 * and toggling the navigation menu for small screens.
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function($) {

	// ----------------------------------------------------------
	// Doc ready
	// ----------------------------------------------------------
	$(document).ready(
		() => {
			// Main Navigation - depends on superfish-1.7.3-yui.
			// if ($('.main-menu.sf-menu').length) {
			//     $('.main-menu.sf-menu').superfish(
			//         {
			//             animation: {opacity: 'show'}, // fade-in and slide-down animation.
			//             autoArrows: false,  // disable generation of arrow mark-up.
			//             delay: 0, // delays on mouseout.
			//             speed: 200 // faster animation speed.
			//         }
			//     );
			// }

			// ----------------------------------------------------------
			// Main Navigation open / close submenus
			// ----------------------------------------------------------
			if ($('.main-menu').length) {
				const mainNavMediaQuery = window.matchMedia('(max-width: 1199px)')

				function handleViewportChange(e)
				{
					// Check if the media query is true
					if (e.matches) {
						$(document).on(
							'click tap keyup',
							'.main-menu .menu-item-has-children > a',
							function(e) {
								let myLi = $(this).parent('.menu-item-has-children');
								// let mySub = $(this).next('.sub-menu');

								// if (myLi.hasClass('submenu-open') || myLi.hasClass('current-menu-item') || myLi.hasClass('current-menu-ancestor')) {
								if (myLi.hasClass('submenu-open')) {
									return true;
								} else {
									e.preventDefault();
									$(myLi).siblings('.menu-item-has-children').removeClass('submenu-open');
									$(myLi).addClass('submenu-open');
								}
							}
						)
						// hide sub-menu on ESC.
						$(document).on(
							'keyup',
							function(e) {
								if (e.keyCode === 13) {
									return true;
								}
								if (e.which === 27) {
									$('.menu-item-has-children').removeClass('submenu-open');
								}
							}
						)
						// hide opened menu by clicking outside it.
						$(document).on(
							'click tap keyup',
							function(e) {
								if (!$(e.target).closest('.main-menu').length) {
									$('.menu-item-has-children').removeClass('submenu-open');
								}
							}
						)
					} else {
						$(document).off(
							'click tap keyup',
							'.main-menu .menu-item-has-children > a'
						)
						let menu_lis = document.querySelectorAll('.submenu-open');
						menu_lis.forEach(menu_li => {
							let menu_li_link = menu_li.querySelector('a');
							let menu_li_btn = menu_li.querySelector('button');
							menu_li_btn.blur();
							menu_li_link.blur();
							menu_li.classList.remove('submenu-open');
						});
					}
				}

				$(document).on(
					'click tap keyup',
					'.submenu-toggle',
					function(e) {
						let myLi = $(this).parent('.menu-item-has-children');
						if (myLi.hasClass('submenu-open')) {
							$(myLi).removeClass('submenu-open');
						} else {
							e.preventDefault();
							$(myLi).siblings('.menu-item-has-children').removeClass('submenu-open');
							$(myLi).addClass('submenu-open');
						}
					}
				);

				// Register event listener
				mainNavMediaQuery.addEventListener('change', handleViewportChange);

				// Initial check
				handleViewportChange(mainNavMediaQuery);
			} // end if main menu exists.

		}
	); // end doc.ready.

})(window.jQuery);

(function(window, document, undefined) {

	// MOBILE SLIDER MENU
	// http://coding.smashingmagazine.com/2013/01/15/off-canvas-navigation-for-responsive-website/
	// helper functions.
	const trim = function(str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	};
	const hasClass = function(el, cn) {
		return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
	};
	const addClass = function(el, cn) {
		if (!hasClass(el, cn)) {
			el.className = (el.className === '') ? cn : el.className + ' ' + cn;
		}
	};
	const removeClass = function(el, cn) {
		if (el) {
			el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
		}
	};
	const setAttributes = function(el, attrs) {
		if (el) {
			for (let key in attrs) {
				el.setAttribute(key, attrs[key]);
			}
		}
	};
	const hasParent = function(el, id) {
		if (el) {
			do {
				if (el.id === id) {
					return true;
				}
				if (el.nodeType === 9) {
					break;
				}
			} while ((el = el.parentNode));
		}
		return false;
	};

	// normalize vendor prefixes.
	const doc = document.documentElement;

	// off-canvas slider actions.
	window.App = (function() {
		let _init = false;
		const app = {};
		const site_nav = document.getElementById('site-nav'),
			header_toggle_btn = document.getElementById('header-menu-toggle'),
			btn_class = 'is-active',
			nav_class = 'js-nav';
		let nav_open = false;

		app.init = function() {
			if (_init) {
				return;
			}
			_init = true;

			app.closeNav = function() {
				if (nav_open) {
					setAttributes(header_toggle_btn, {'title': 'Main Menu', 'aria-expanded': 'false'});
					setAttributes(site_nav, {'aria-expanded': 'false'});
				}
				removeClass(doc, nav_class);
				removeClass(header_toggle_btn, btn_class);
				nav_open = false;
			};
			app.openNav = function() {
				if (nav_open) {
					return;
				}
				addClass(doc, nav_class);
				addClass(header_toggle_btn, btn_class);
				setAttributes(header_toggle_btn, {'title': 'Close Menu', 'aria-expanded': 'true'});
				setAttributes(site_nav, {'aria-expanded': 'true'});
				nav_open = true;
			};
			app.toggleNav = function(e) {
				if (nav_open && hasClass(doc, nav_class)) {
					app.closeNav();
				} else {
					app.openNav();
				}
				if (e) {
					e.stopPropagation();
					e.preventDefault();
				}
			};
			// open nav with main "nav" button.
			if (header_toggle_btn !== undefined) {
				header_toggle_btn.addEventListener('click', app.toggleNav, false);
			}
			// close nav by touching the partial off-screen content.
			document.addEventListener(
				'click',
				function(e) {
					if (nav_open && !hasParent(e.target, 'header-container') && !hasParent(e.target, 'header-search')) {
						e.stopPropagation();
						e.preventDefault();
						app.closeNav();
					}
				},
				true
			);
			addClass(doc, 'js-ready');
		};
		return app;
	})();
	if (window.addEventListener) {
		window.addEventListener('DOMContentLoaded', window.App.init, false);
	}
	// end MOBILE SLIDER MENU.

})(window, window.document);
